import fields from '@/sui/data/sheets/edit/fields'

const correct = 'merci de vous assurer que la valeur est correcte'

export default {
  birthWeight: {
    field: fields.birthWeight,
    bounds: {
      upper: 6000,
      lower: 500
    },
    message: {
      above: `Le poids de naissance semble élevé (>6kg), ${correct}`,
      below: `Le poids de naissance semble bas (<500g), ${correct}`,
      type: 'warning'
    }
  },
  gestationalAge: {
    field: fields.gestationalAge,
    bounds: {
      upper: 50,
      lower: 21
    },
    message: {
      above: `L'âge gestationnel semble élevé (>50 SA), ${correct}`,
      below: `L'âge gestationnel semble bas (<21 SA), ${correct}`,
      type: 'warning'
    }
  },
  igsII: {
    field: fields.igsII,
    bounds: {
      lower: 0,
      upper: 163,
      special: [ 999 ]
    },
    message: {
      above: `Le score doit être compris entre 0 et 163, ou 999 si non connu.`,
      below: `Le score doit être compris entre 0 et 163, ou 999 si non connu.`,
      type: 'error'
    }
  },
  pimII: {
    field: fields.pimII,
    bounds: {
      lower: 0,
      upper: 100,
      special: [ 999 ]
    },
    message: {
      above: `Le score doit être compris entre 0 et 100, ou 999 si non connu.`,
      below: `Le score doit être compris entre 0 et 100, ou 999 si non connu.`,
      type: 'error'
    }
  },
  cribII: {
    field: fields.cribII,
    bounds: {
      lower: 0,
      upper: 27,
      special: [ 999 ]
    },
    message: {
      above: `Le score doit être compris entre 0 et 27, ou 999 si non connu.`,
      below: `Le score doit être compris entre 0 et 27, ou 999 si non connu.`,
      type: 'error'
    }
  },
  height: {
    field: fields.height,
    bounds: {
      lower: 56,
      upper: 270
    },
    message: {
      above: `La taille semble trop grande.`,
      below: `La taille semble trop petite.`,
      type: 'warning'
    }
  },
  weight: {
    field: fields.weight,
    bounds: {
      lower: 10,
      upper: 200
    },
    message: {
      above: `Le poids semble trop important.`,
      below: `Le poids semble trop bas.`,
      type: 'warning'
    }
  },
  bmi: {
    field: fields.bmi,
    bounds: {
      lower: 15,
      upper: 50,
      special: [ 99 ]
    },
    message: {
      above: `L'IMC semble trop important. (Valeur habituellement entre 15 et 50, 99 pour non connu)`,
      below: `L'IMC semble trop bas. (Valeur habituellement entre 15 et 50, 99 pour non connu)`,
      type: 'warning'
    }
  },
  rinsingSuccessivePushesCount: {
    field: fields.rinsingSuccessivePushesCount,
    bounds: {
      lower: 2,
      upper: 10
    },
    message: {
      above: 'Le nombre de poussées successives semble élevé.',
      below: 'Le nombre de poussées successives doit être supérieur à 1.',
      belowType: 'error',
      aboveType: 'warning'
    }
  }
}
